<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.vendors.add_vendor_dimensions')"
  :rightActions="rightActions"
  width="900"
)
  UiFormGroup
    RestTable(
      :headers="headers"
      :fetchHandler="getData"
      namespace="dimension_items"
      :itemsPerPageAttachDropdownToBody="false"
      ref="companyDimensionsTable"
    )
      template(#filters="{ filters, updateFilters }")
        UiFormGroup(:label="$t('companies.dimensions.name')")
          UiInput(
            :modelValue="filters.search"
            type="search"
            @update:modelValue="updateFilters({ search: $event })"
          )
      template(#cell:select="{ item }")
        UiCheckbox(
          v-model="item.assigned_to_vendor"
          switch
          @update:modelValue="checkItem(item)"
        )
</template>

<script>
import ApiVendorDimensionItems from "@/api/vendorDimensionItems.js";

export default {
  data() {
    return {
      show: false,
      companyId: null,
      vendorId: null,
      form: {},
      headers: [
        {
          key: "dimension_name",
          label: "Dimension",
          squeeze: false,
        },
        {
          key: "name",
          label: "Dimension Item",
          squeeze: false,
        },
        {
          key: "select",
          label: "",
          squeeze: false,
        },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.close,
        },
      ];
    },
  },

  methods: {
    open(companyId, vendorId, selectedItems) {
      this.companyId = companyId;
      this.vendorId = vendorId;
      this.selectedItems = selectedItems;
      this.show = true;
    },

    close() {
      this.$emit("done");
      this.show = false;
    },

    reloadList() {
      this.$refs.companyDimensionsTable.fetchData();
    },

    getData(params, config) {
      return ApiVendorDimensionItems.vendorDimensionItems(
        this.companyId,
        this.vendorId,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.dimension_items,
          meta: resp.data.meta,
        };
      });
    },

    checkItem(item) {
      if (item.assigned_to_vendor) {
        ApiVendorDimensionItems.assignDimensionItem(
          this.companyId,
          this.vendorId,
          item.id,
        ).then((resp) => {});
      } else {
        ApiVendorDimensionItems.deassignDimensionItem(
          this.companyId,
          this.vendorId,
          item.id,
        ).then((resp) => {});
      }
    },
  },
};
</script>
